import { Toaster as Sonner, ToasterProps } from "sonner";

import { cn } from "@shadcn/lib/utils";
import { AlertTriangle, CheckCircle, Info, Loader, XCircle } from "lucide-react";
const Toaster = (props: ToasterProps) => {
	return (
		<Sonner
			theme="light"
			className="toaster group"
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
				} as React.CSSProperties
			}
			toastOptions={{
				classNames: {
					toast: cn(
						"group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pointer-events-auto"
					),

					description: "group-[.toast]:text-muted-foreground",
					actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
					cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
				},
			}}
			icons={{
				success: <CheckCircle className="h-4 w-4 text-green-500" />,
				info: <Info className="h-4 w-4 text-blue-500" />,
				warning: <AlertTriangle className="h-4 w-4 text-amber-500" />,
				error: <XCircle className="h-4 w-4 text-red-500" />,
				loading: <Loader className="h-4 w-4 text-gray-500 animate-spin" />,
			}}
			{...props}
		/>
	);
};

export { Toaster };
